import api from "../../database";

export interface IProfileUpdate {
  name?: string;
  cellphone?: string;
  oldPassword?: string;
  newPassword?: string;
}

export interface IUpdatedProfile {
  name: string;
  cellphone: string;
}

export const updateProfile = async (
  data: IProfileUpdate,
  token: string,
): Promise<IUpdatedProfile> => {
  const response = await api.patch("/user/update", data, {
    headers: { "x-access-token": token },
  });
  return response.data?.user;
};
